var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStockLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.75 33.625H4.05C3.06991 33.625 2.57986 33.625 2.20552 33.4297C1.87623 33.2579 1.60852 32.9839 1.44074 32.6467C1.25 32.2635 1.25 31.7618 1.25 30.7583V1.375M32.75 8.54167L23.2399 18.2781C22.8934 18.6329 22.7202 18.8103 22.5204 18.8768C22.3447 18.9352 22.1553 18.9352 21.9796 18.8768C21.7798 18.8103 21.6066 18.6329 21.2601 18.2781L17.9899 14.9302C17.6434 14.5754 17.4702 14.398 17.2704 14.3316C17.0947 14.2731 16.9053 14.2731 16.7296 14.3316C16.5298 14.398 16.3566 14.5754 16.0101 14.9302L8.25 22.875M32.75 8.54167H25.75M32.75 8.54167V15.7083",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockLight);
export default __webpack_public_path__ + "static/media/stock_light.ca5680cc5377913124cd44d3f3bd9fb8.svg";
export { ForwardRef as ReactComponent };